/**
 * Use inside `.HStack` and `.VStack` to use up available space
 * eg. to split a flex container into left & right sides.
 */
export const Spacer = () => <div className="Spacer" />;
